import { FilterModel, TimeFilter } from '../model/interfaces';

export const TIME_FILTERS: TimeFilter[] = [
  {Days: 'P30D', Text: 'Past 30 days'},
  {Days: 'P90D', Text: 'Past 90 days'},
  {Days: 'P6M', Text: 'Past 6 months'},
  {Days: 'P12M', Text: 'Past 12 months'},
  {Days: 'YTD', Text: 'Year to date'},
  {Days: 'PY', Text: 'Previous year'},
  {Days: 'DR', Text: 'Date Range'}
];

export const DOCUMENT_TYPES: FilterModel[] = [
  {Value: '%', Text: 'Statements & Inserts'},
  {Value: 'S', Text: 'Statements only'},
  {Value: 'I', Text: 'Inserts only'}
];

export const READ_FILTERS: FilterModel[] = [
  { Value: 'all', Text: '' },
  { Value: 'unread', Text: 'Unread' },
  { Value: 'read', Text: 'Read' }
];
